import { useSelector } from 'react-redux';

export const usePaddle = (override = null) => {
  const user = useSelector(({ User }) => User.data);
  const reduxOverride = useSelector(({ PaymentProvider }) => PaymentProvider.override);

  // Use the provided override if it exists, otherwise use the Redux override
  const effectiveOverride = override !== null ? override : reduxOverride;

  console.log('usePaddle', {
    override: effectiveOverride,
    paddle_id: user?.paddle_id,
    stripe_id: user?.stripe_id,
  });

  // 1. If override is provided, use that value
  if (effectiveOverride !== null) {
    return effectiveOverride;
  }

  // 2. Otherwise, use Paddle
  return true;
};

export default usePaddle;
